// Note: the actual expiry is 1 hour, but we subtract a 5 minute safety margin
const GOOGLE_ACCESS_TOKEN_EXPIRY = 55 * 60 * 1000; // 55 minutes

export class GoogleAccessTokenDeserializationError extends Error {}

export default class GoogleAccessToken {
  constructor(
    private readonly accessToken: string,
    private readonly issuedAt: Date = new Date(),
  ) {}

  getValue(): string {
    return this.accessToken;
  }

  isExpired(): boolean {
    const expirationTimestamp =
      this.issuedAt.valueOf() + GOOGLE_ACCESS_TOKEN_EXPIRY;

    return Date.now() >= expirationTimestamp;
  }

  serialize(): object {
    return {
      accessToken: this.accessToken,
      issuedAt: this.issuedAt.valueOf(),
    };
  }

  static fromSerialized(serializedAccessToken: unknown): GoogleAccessToken {
    if (
      typeof serializedAccessToken !== 'object' ||
      serializedAccessToken === null ||
      !('accessToken' in serializedAccessToken) ||
      !('issuedAt' in serializedAccessToken) ||
      typeof serializedAccessToken.accessToken !== 'string' ||
      typeof serializedAccessToken.issuedAt !== 'number'
    ) {
      throw new GoogleAccessTokenDeserializationError(
        'Cannot deserialize malformed Google access token.',
      );
    }

    return new GoogleAccessToken(
      serializedAccessToken.accessToken,
      new Date(serializedAccessToken.issuedAt),
    );
  }
}
